"use client"

import CardMeta from "@/components/common/Card/Meta"
import SkeletonImage from "@/components/common/Skeleton/Image"
import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import { Card, Col, ColProps, ConfigProvider, Skeleton } from "antd"

type ProductItemSkeletonProps = {
  customGridProduct?: number,
  store: TypeStoreDetail
}

const ProductItemSkeleton = ({ store, ...props }: ProductItemSkeletonProps) => {
  const gridProducts = props.customGridProduct || store.products_per_category_section

  const imageSize: any = {
    1: {
      height: 1200,
      width: 1200 * 0.8
    },
    2: {
      height: 1000,
      width: 1000 * 0.8
    },
    3: {
      height: 900,
      width: 900 * 0.8
    },
    4: {
      height: 700,
      width: 700 * 0.8
    },
    5: {
      height: 500,
      width: 500 * 0.8
    }
  }

  const shownPrevieColors = store?.shown_preview_colors
  const secondaryCard = store.card_product === 'secondary'

  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: store.product_card_text_color
        }
      }}
    >
      <Col
        className={`product__list--item product__list--item-${gridProducts || 5}`}
      >
        <Card
          variant="outlined"
          hoverable
          style={{ height: "100%", maxWidth: "100%" }}
          styles={{
            cover: {
              alignItems: 'center'
            }
          }}
          cover={<SkeletonImage active styles={{ root: { width: "100%", height: "100%" } }} style={{ height: "100%", width: '100%' }} />}
        >
          <CardMeta
            title={<Skeleton styles={{ title: { marginTop: 0, marginBottom: 8, height: '2.2rem' } }} paragraph={false} />}
            description={(
              <Skeleton paragraph={false} styles={{ title: { marginTop: 0, marginBottom: 8, height: '2.2rem' } }} />
            )}
          />
        </Card>
      </Col>
    </ConfigProvider>
  )
}

export default ProductItemSkeleton